import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import menuItem from 'menu-items';
import { useGetMenuMaster } from 'api/menu';
// import { useAuth } from 'contexts/AuthContext'; // TODO: enable for production

function buildMenuItems(items/*, hasPermission*/) {
  return items.map((item) => {
    if (item.type === 'group') {
      // if (!hasPermission(item.id)) return null; // TODO: enable for production
      const children = buildMenuItems(item.children || []/*, hasPermission*/);
      if (!children.length) return null;
      return { type: 'group', key: item.id, label: item.title, children };
    }
    if (item.type === 'collapse') {
      const Icon = item.icon;
      const children = buildMenuItems(item.children || []/*, hasPermission*/);
      return { key: item.id, icon: Icon ? <Icon /> : null, label: item.title, children };
    }
    if (item.type === 'item') {
      const Icon = item.icon;
      return { key: item.url, icon: Icon ? <Icon /> : null, label: item.title };
    }
    return null;
  }).filter(Boolean);
}

export default function Navigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  // const { hasPermission } = useAuth(); // TODO: enable for production

  const items = buildMenuItems(menuItem.items/*, hasPermission*/);

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[pathname]}
      inlineCollapsed={!drawerOpen}
      items={items}
      onClick={({ key }) => {
        if (key.startsWith('http')) window.open(key, '_blank');
        else navigate(key);
      }}
      style={{ border: 'none', paddingTop: 8 }}
    />
  );
}
